import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { LtAvatarComponent } from '@app/components/core/lt-avatar/lt-avatar.component';
import { LtIconComponent } from '@app/components/core/lt-icon/lt-icon.component';
import type { IconName } from '@app/components/core/lt-icon/lt-icon.config';
import type { LookImage } from '@app/interface/image/look-image.interface';

export interface StudentCart {
  id: string;
  name: string;
  lookImage?: LookImage | null;
  state: 'empty' | 'complete';
}

type Severity = 'default' | 'success';

@Component({
  selector: 'lt-student-chiclet',
  standalone: true,
  imports: [CommonModule, LtIconComponent, LtAvatarComponent],
  templateUrl: './student-chiclet.component.html',
  styleUrls: ['./student-chiclet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StudentChicletComponent {
  student = input.required<StudentCart>();
  severity = input<Severity | null>(null);

  selected = output<void>();

  private static readonly SEVERITY_MAP: Record<string, { icon: IconName; class: string }> = {
    success: {
      icon: 'fa-sharp-solid-check-circle',
      class: 'student-chiclet--green'
    },
    default: {
      icon: 'fa-sharp-regular-plus-circle',
      class: 'student-chiclet--blue'
    }
  };

  selectStudent(): void {
    this.selected.emit();
  }

  studentStatus = computed(() => {
    const state = this.student().state;

    const severity = state === 'complete' ? 'success' : 'default';
    return StudentChicletComponent.SEVERITY_MAP[severity];
  });
}
